import {_} from 'lodash';
import * as ko from "knockout";
import {IVariableParams} from "./VariableAbstract";
import {ICompanySyncstep, IKnockoutComponent, ISyncstep} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {global} from "../../appContext";
import {getAnyValue} from "../../util/misc";
import {isRoutePermissionOkay} from "../../constants/RouteDefinitions";
import {nsSync} from "../../util/nsSync";
import syncstep_or_companysyncstepHtml from './syncstep-or-companysyncstep.html?raw';

export const template = syncstep_or_companysyncstepHtml

type T = ICompanySyncstep | ISyncstep;

export class viewModel {

    private readonly req_getcompanysyncsteps: PromiseRequest = global.getPromiseRequest('getcompanysyncsteps')
    private readonly req_getsyncsteps: PromiseRequest = global.getPromiseRequest('getsyncsteps')
    private isReady: KnockoutObservable<boolean | null> = ko.observable(null)
    private component!: IKnockoutComponent
    private name: KnockoutObservable<string | null> = ko.observable(null)
    private item!: T
    private id: number

    constructor(protected params: IVariableParams<T>) {
        if (params.item) {
            this.item = getAnyValue(params.item)
            if ('name' in this.item) {
                this.name(nsSync.getSyncstepName(this.item))
                this.id = this.item.id
                this.component = this.getComponent_syncstep(this.item)
            } else {
                this.name(nsSync.getSyncstepName(this.item.syncstep))
                this.id = this.item.syncstep.id
                this.component = this.getComponent_companysyncstep(this.item)
            }
            this.isReady(true)
        } else {
            this.id = getAnyValue(params.id) ?? 0;
            this.init()
        }
    }

    private init() {
        Promise.resolve()
            .then(() => {
                if (global.permissionValidator.isMinSuperManager()) {
                    return this.req_getcompanysyncsteps
                        .request()
                        .then((data: ICompanySyncstep[]) => {
                            const companySyncstep = data.find(o => o.syncstep.id == this.id)
                            if (companySyncstep) {
                                this.component = this.getComponent_companysyncstep(companySyncstep)
                            }
                        })
                } else {
                    return this.req_getsyncsteps
                        .request()
                        .then((data: ISyncstep[]) => {
                            const syncstep = data.find(o => o.id == this.id)
                            if (syncstep) {
                                this.component = this.getComponent_syncstep(syncstep)
                            }
                        })
                }
            })
            .then(() => {
                this.name(null)
                this.isReady(true)
            })
    }

    private getComponent_companysyncstep(item: ICompanySyncstep): IKnockoutComponent {
        return {
            name: 'component/variable/companysyncstep',
            params: _.defaults({item: item}, this.params),
        }
    }

    private getComponent_syncstep(item: ISyncstep): IKnockoutComponent {
        return {
            name: 'component/variable/syncstep',
            params: _.defaults({item: item, linkable: isRoutePermissionOkay('syncstatusv2')}, this.params),
        }
    }

    dispose() {
        this.req_getsyncsteps.abort()
        this.req_getcompanysyncsteps.abort()
    }
}